import * as localizations from './localizations'
export const appStrings = localizations

export * from './components/LocalizerRouter'
export * from './components/MultiLangualSwitch'
export * from './components/LocalizerLink'
export * from './components/LocalizerSwitcher'
